import { colorUsage } from 'stylesheet';
var paletteOverride = {
  primary: {
    main: colorUsage.paletteOverride.primary.main
  }
};
export default paletteOverride;